
import Vue from 'vue';
import { PgyCommonSdk } from '@fdfe/marketing-sdk';
import { eventHub, OPEN_HANDLER, env } from '@/common/index';
import { runtimeMap } from '@/common/utils';

export default Vue.extend({
  name: 'GuideButton',
  components: {
    PgyCommonSdk,
  },
  props: {
    needReport: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: '立即开启',
    },
  },
  data() {
    return {
      utmSource: env.utmSource,
      runtime: runtimeMap[env.runtime],
    };
  },
  methods: {
    open() {
      eventHub.$emit(OPEN_HANDLER, this.needReport);
    },
  },
});
